import noUiSlider from "nouislider";

const SubscriptionPlans = () => {
	const block = document.querySelectorAll(".subscription-plans");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const items = el.querySelectorAll(".subscription-plans__list-item");
		const list = el.querySelector(".subscription-plans__list");

		list.setAttribute("data-col", items.length);

		items.forEach((item) => {
			const sizeRange = item.querySelector(".subscription-plans__card-range");
			
			if (sizeRange) {
				const rangeInfo = item.querySelector(".subscription-plans__card-info");
				const rangeInfoOldPrice = rangeInfo.querySelector(".subscription-plans__card-info-old");
				const priceYearly = item.querySelector(".subscription-plans__card-price-year");
				const priceMonthly = item.querySelector(".subscription-plans__card-price-month");
				const valuesForSlider = sizeRange.getAttribute("data-values").split(",");
				const valuesYearly = sizeRange.getAttribute("data-values-yearly").split(",");
				const valuesMonthly = sizeRange.getAttribute("data-values-monthly").split(",");
				const format = {
					to: function(value) {
						return valuesForSlider[Math.round(value)];
					},
					from: function (value) {
						return valuesForSlider.indexOf(value);
					}
				};
				noUiSlider.create(sizeRange, {
					start: [valuesForSlider[1]],
					connect: [true, false],
					step: 1,
					range: {
						min: 0,
						max: valuesForSlider.length - 1
					},
					format: format,
					pips: {
						mode: 'steps',
						format: format,
						density: 50
					}
				});
				sizeRange.noUiSlider.on("update", function (values, handle) {
					const currentIndex = valuesForSlider.indexOf(values[handle]);

					priceYearly.textContent = `$${valuesYearly[currentIndex]}`;
					priceMonthly.textContent = `$${valuesMonthly[currentIndex]}`;

					if (currentIndex < 2) {
						rangeInfo.style.opacity = "1";
						rangeInfoOldPrice.textContent = `$${valuesMonthly[currentIndex] * 2}`;
					} else {
						rangeInfo.style.opacity = "0";
					}
				});
			}
		});
	});
};

export default SubscriptionPlans;
